import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-77bbbf9a")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "img-box" }
const _hoisted_4 = {
  key: 0,
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png"
}
const _hoisted_5 = { class: "farmer-name" }
const _hoisted_6 = {
  key: 0,
  class: "resoure-tip"
}
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "r-detail" }
const _hoisted_10 = {
  key: 0,
  class: "img-box"
}
const _hoisted_11 = { class: "r-title-detail" }
const _hoisted_12 = { class: "r-name" }
const _hoisted_13 = { class: "r-remark" }
const _hoisted_14 = { class: "r-time" }
const _hoisted_15 = { class: "r-location" }
const _hoisted_16 = { class: "distance" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.initInfo.headImg || _ctx.initInfo.headImg.length == 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createBlock(_component_van_image, {
              key: 1,
              width: "5rem",
              height: "5rem",
              src: _ctx.initInfo.headImg[0].url,
              fit: "cover"
            }, null, 8, ["src"]))
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.initInfo.farmerName), 1)
    ]),
    (_ctx.initInfo.sourceTouristList.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 资源信息 "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.sourceTouristList, (value) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "resoure",
          onClick: ($event: any) => (_ctx.toDetail(value.sourceId)),
          key: value.id
        }, [
          _createElementVNode("span", {
            class: "cooperation",
            style: _normalizeStyle(`background:${_ctx.getColorful(value.cooperationId)}`)
          }, _toDisplayString(value.cooperationName), 5),
          _createElementVNode("div", _hoisted_9, [
            (value.img != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_van_image, {
                    src: value.sourceImg.length!=0?value.sourceImg[0].url:'https://qnui.xfarmer.com/xfarmer-ui/public/default_source.png',
                    fit: "cover",
                    width: "6.8125rem",
                    height: "6.8125rem"
                  }, null, 8, ["src"])
                ]))
              : (_openBlock(), _createBlock(_component_van_image, {
                  key: 1,
                  width: "6.8125rem",
                  height: "6.8125rem",
                  src: ""
                })),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(value.sourceName), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(value.remark), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(value.launchDate) + "上市", 1),
                _createElementVNode("span", null, "供应" + _toDisplayString(value.supplyCycle) + "天", 1),
                _createElementVNode("span", null, "产量" + _toDisplayString(value.yield) + "斤", 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(value.addressInfo), 1),
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_van_icon, { name: "location-o" }),
                  _createTextVNode(_toDisplayString(value.distance) + "km", 1)
                ])
              ])
            ])
          ])
        ], 8, _hoisted_8))
      }), 128))
    ])
  ]))
}